let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("c3bpv")).then(() => parcelRequire('02NP0'));